// extracted by mini-css-extract-plugin
module.exports = {"footer":"EditIntroductionModal_footer__r-HVD","introduction-text":"EditIntroductionModal_introduction-text__1Wplw"};